// extracted by mini-css-extract-plugin
module.exports = {"sortContainer":"BubbleSort_sortContainer__3FO8P","algorithmAnimate":"BubbleSort_algorithmAnimate__12F8S","itemWrapper":"BubbleSort_itemWrapper__3EvaY"};